import React, { useState } from "react";
import { toast } from "sonner";
import { adminApi, getErrorMessage } from "@/lib/api";
import { Pill, aud } from "./ui";

function FaultItem({ f, onSaved }) {
  const [val, setVal] = useState(f.confirmed_root_cause || "");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try { await adminApi.patch(`/admin/wi/faults/${f.id}`, { confirmed_root_cause: val }); toast.success("Root cause saved"); onSaved?.(); }
    catch (e) { toast.error(getErrorMessage(e)); } finally { setBusy(false); }
  };
  return (
    <li className="border border-neutral-800 rounded-xl p-3 space-y-1.5" data-testid="wi-fault-item">
      <div className="flex flex-wrap items-center gap-2 text-sm">
        <span className="text-white font-semibold">{f.component}</span><span className="text-neutral-500 text-xs">{f.system}</span>
        {f.safety_critical && <Pill tone="red">Safety-critical</Pill>}{f.repeat && <Pill tone="amber">Repeat on this caravan</Pill>}
        <span className="ml-auto text-xs text-[#d9b45b] tabular-nums">{aud(f.cost, 2)}</span>
      </div>
      <p className="text-xs text-neutral-300"><span className="text-neutral-500">Reported: </span>{f.symptoms || "—"}</p>
      {f.suspected_cause && <p className="text-xs text-neutral-400"><span className="text-neutral-500">Suspected (AI hypothesis): </span>{f.suspected_cause}</p>}
      <div className="flex gap-2 pt-1">
        <input value={val} onChange={(e) => setVal(e.target.value)} maxLength={600} placeholder="Confirmed root cause (engineering)" data-testid="wi-fault-root-cause"
          className="flex-1 bg-black/40 border border-neutral-800 rounded-lg px-2.5 py-1.5 text-xs text-white outline-none focus:border-[#73bf44] placeholder:text-neutral-600" />
        <button onClick={save} disabled={busy || val === (f.confirmed_root_cause || "")} className="text-xs font-semibold text-[#73bf44] hover:text-white disabled:opacity-40" data-testid="wi-fault-save">Save</button>
      </div>
    </li>
  );
}

export function FaultList({ faults, onSaved }) {
  if (!faults?.length) return <div className="text-sm text-neutral-500">No faults recorded.</div>;
  return <ul className="space-y-2">{faults.map((f) => <FaultItem key={f.id} f={f} onSaved={onSaved} />)}</ul>;
}
